export class ConsentModel {
    applicationId: number;
    consentId: number;
    softInquiryConsent: boolean;
    softInquiryConsentDate: Date;
    marComConsent: boolean;
    eConsent: boolean;
    marComConsentDate: Date;
    emailVerified: boolean;
    smsVerified: boolean;
    hardInquiryConsent: boolean;
    hardInquiryConsentDate: Date;
    emailUnsubscribe: boolean;
    emailUnsubscribeDate: Date;
    smsUnsubscribe: Date;
    smsUnsubscribeDate: Date;
    depositFinalConsent: boolean;
    consent1_individual: boolean;
    consent2_individual: boolean;
    consent3_individual: boolean;
    consent4_individual: boolean;
    finalConsent_individual: boolean;

    constructor() {
        this.softInquiryConsent = false;
        this.marComConsent = false;
        this.depositFinalConsent = false;
    }
}
